<template>
  <div
    class="loader"
  >
    <b-input-group style="overflow:hidden" >
      <b-form-file
        title=""
        size="sm"
        @change="change"
        @dragover="dragover"
        @drop="drop"
        v-if="uploadReady1 && data.close1===false"
        ref="fileInput"
        name="fileInput"
        placeholder="Seleccionar"
        accept=".jpg,.jpeg,.pdf"
        browse-text=" "
        :disabled="dataForm[namePath].subir_archivos[0]!==undefined"
      >
      </b-form-file>      
      <b-input-group-append>
        <b-button @click="resetFile(0)" v-if="trashFile.one" style="padding: 0" variant="outline-danger"><b-icon icon="trash"></b-icon></b-button>
      </b-input-group-append>
    </b-input-group>
     <b-input-group v-if="ifFile" style="margin-top:10px">
      <b-form-file
        title=""
        size="sm"
        @change="change"
        @dragover="dragover"
        @drop="drop"
        v-if="uploadReady2 && data.close2===false"
        ref="fileInput2"
        placeholder="Seleccionar"
        accept=".jpg,.jpeg"
        browse-text=" "
        :disabled="dataForm[namePath].subir_archivos[1]!==undefined"
      >
      </b-form-file>      
      <b-input-group-append>
        <b-button  v-if="trashFile.two"  @click="resetFile(1)" style="padding: 0" variant="outline-danger"><b-icon icon="trash"></b-icon></b-button>
      </b-input-group-append>
    </b-input-group>
    
  </div>
</template>

<script>
const Compress = require('compress.js')
const URL = window.URL || window.webkitURL;
const compress = new Compress()

export default {
  name: 'Loader',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    tabla: {
      type: String,
      default: ''
    },
    campo: {
      type: String,
      default: ''
    },
    indexTable: {
      default :false
    },
    indexGet: {
      default :false
    },
    index: {
      default :false
    }
  },
  data()
  {
    return {
      files: {},
      lastTarget: null,
      uploadReady1: true,
      uploadReady2: true,
      fileData: '',
    }
  },
  updated()
  {
    if(this.data.loaded===false && this.data.url==='' && this.data.close1===true)
    {
      if(this.data.index===0)
      {
        this.uploadReady1 = false
        this.$nextTick(() => {
            this.uploadReady1 = true
        })
        this.updateDataForm({state: 'subir_archivos', data: []})
        if(this.index!==false)
        {
          this.updateDataForm({state: this.tabla+'/'+this.campo, data: []})
        }
        else 
        {
          this.updateDataGet({state: this.tabla+'/'+this.indexTable+'/'+this.campo, data: [], index: this.indexGet})
        }
        
      }      
      this.data.close1=false
    }
    if(this.data.loaded===false && this.data.url==='' && this.data.close2===true)
    {
      if(this.data.index===1)
      {
        this.uploadReady2 = false
        this.$nextTick(() => {
            this.uploadReady2 = true
        })
        this.spliceDataForm({state: 'subir_archivos', index: this.data.index })
        
        if(this.indexGet===false)
        {
          this.spliceDataForm({state: this.tabla+'/'+this.campo, index: this.data.index })
        }        
        else 
        {
          let arrayDataGet= this.deepCopy(this.dataGet[this.namePath].data[this.indexGet][this.tabla][this.indexTable][this.campo])
          arrayDataGet.splice(this.data.index,1) 
          this.updateDataGet({state: this.tabla+'/'+this.indexTable+'/'+this.campo, data: arrayDataGet,index: this.indexGet}) 
        }     
      } 
      this.data.close2=false
    }

  },
  created(){
    this.updateDataForm({state: 'subir_archivos', data: []})
    if(this.indexGet!==false) 
    {
      this.updateDataGet({state: this.tabla+'/'+this.indexTable+'/'+this.campo, data: [], index: this.indexGet})
    }
  },
  computed:
  {
    disabledFile()
    {
      return true
    },
    ifFile()
    {
      let one=false
      if(this.indexGet===false)
      {
        if(this.dataForm[this.namePath][this.tabla][this.campo].length>0 && this.dataForm[this.namePath]['subir_archivos'][0].type==='image/jpeg')
        {
          one=true
        }
      }else {
        if(this.dataGet[this.namePath].data[this.indexGet][this.tabla][this.indexTable][this.campo].length>0 && this.dataForm[this.namePath]['subir_archivos'][0].type==='image/jpeg')
        {
          one=true
        }
      }  
    
      return one
    },
    trashFile()
    {
      let lengthValue=0
      let one=false
      let two=false
      if(this.indexGet===false)
      {
        lengthValue=this.dataForm[this.namePath][this.tabla][this.campo].length
        if(lengthValue===1)
        {
          one=true
        }
        if(lengthValue===2)
        {
          one=true
          two=true
        }
      }else {
        lengthValue=this.dataGet[this.namePath].data[this.indexGet][this.tabla][this.indexTable][this.campo].length
        if(lengthValue===1)
        {
          one=true
        }
        if(lengthValue===2)
        {
          one=true
          two=true
        }
      }
      return {one: one, two: two}
    }
  },
  methods: {
    async read(files) {
      return new Promise((resolve, reject) => {
        if (!files || files.length === 0) {
          resolve({
            cropped: false,
            cropping: false,
            loaded: false,
            name: '',
            previousUrl: '',
            type: '',
            url: '',
            index: 0,
            url2: '',
            close: false,
          });
          return;
        }
        const file = files[0];
        
        
        const imageData = {}
        if (/^image\/\w+$/.test(file.type)) {
          compress.compress([...files], {
            size: 4, // the max size in MB, defaults to 2MB
            quality: .65, // the quality of the image, max is 1,
            maxWidth: 1000, // the max width of the output image, defaults to 1920px
            maxHeight: 1000, // the max height of the output image, defaults to 1920px
            resize: true, // defaults to true, set false if you do not want to resize the image width and height
          }).then(async (data) => {
             if (URL) {
                var imageData = {
                  loaded: true,
                  name: file.name,
                  type: file.type,
                  url: data[0].prefix+data[0].data,
                  url2: URL.createObjectURL(file),
                };
              }       
            resolve(imageData)      
          })
        }
        else 
        {
          var reader  = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend =  async function() {              
            if (URL) {
              var imageDatas = {
                loaded: false,
                name: file.name,
                type: file.type,
                url: reader.result,
                url2: URL.createObjectURL(file),
              }
            }              
            resolve(imageDatas) 
          }
        }
      })
    },

    

    change({ target }) {
      this.read(target.files).then((data) => {
        let type = data.type.split('/')
        let url = data.url2.split('/')
        let base64 = data.url
        this.pushDataForm({state: 'subir_archivos', data: {             
            name: _.last(url)+'.'+_.last(type),
            base64:  data.url,
            type: data.type,
          }
        })
        
        if(this.indexGet===false)
        {
          this.pushDataForm({state: this.tabla+'/'+this.campo, data: _.last(url)+'.'+_.last(type)})  
        }
        else{              
          let arrayDataGet= this.deepCopy(this.dataGet[this.namePath].data[this.indexGet][this.tabla][this.indexTable][this.campo])
          arrayDataGet.push(_.last(url)+'.'+_.last(type))

          this.updateDataGet({state: this.tabla+'/'+this.indexTable+'/'+this.campo, index: this.indexGet, data: arrayDataGet}) 
        } 
        this.lastTarget=target
        target.value = '';
        (target.name==='fileInput') ? data.index=0 : data.index=1 ;
        this.update(data);
      }).catch((e) => {
        target.value = '';
        this.alert(e);
      });
    },

    dragover(e) {
      e.preventDefault();
    },

    drop(e) {
      e.preventDefault();
      this.read(e.dataTransfer.files)
        .then((data) => {
          this.update(data);
        })
        .catch(this.alert);
    },

    resetFile(index)
    {
      if(index===0)
      {
        this.uploadReady1 = false
        this.$nextTick(() => {
            this.uploadReady1 = true
        })
        this.updateDataForm({state: 'subir_archivos', data: []})
        if(this.indexGet===false)
        {
          this.updateDataForm({state: this.tabla+'/'+this.campo, data: []})
        }
        else 
        {
          this.updateDataGet({state: this.tabla+'/'+this.indexTable+'/'+this.campo, data: [], index: this.indexGet})
        }
      }
      else 
      {
        this.uploadReady2 = false
        this.$nextTick(() => {
            this.uploadReady2 = true
        })        
        this.spliceDataForm({state: 'subir_archivos', index: index })
        if(this.indexGet===false)
        {
          this.spliceDataForm({state: this.tabla+'/'+this.campo, index: index })
        }
        else 
        {
          let arrayDataGet= this.deepCopy(this.dataGet[this.namePath].data[this.indexGet][this.tabla][this.indexTable][this.campo])
          arrayDataGet.splice(index,1) 
          this.updateDataGet({state: this.tabla+'/'+this.indexTable+'/'+this.campo, data: arrayDataGet, index: this.indexGet})
        }
      }
    },

    alert(e) {
      window.alert(e && e.message ? e.message : e);
    },
    update(data) {
      Object.assign(this.data, data);
    },
  },
};
</script>

<style scoped>
.loader {
  display: table;
  height: 100%;
  overflow: hidden;
  width: 100%;
}

.loader > p {
    color: #999;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
  }

.browse {
  color: #0074d9;
  cursor: pointer;
  margin-left: .25rem;  
}

.browse:hover {
    color: #08f;
    text-decoration: underline;
  }
  
.custom-file.b-form-file {
  border-right: 1px solid;
}
</style>
